"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeApiHelper = void 0;
/**
 * Static helper class for knowledge-related API operations
 */
class KnowledgeApiHelper {
    /**
     * Load knowledge entries with optional search query
     */
    static async loadKnowledgeEntries(apiService, searchQuery, perPage = 20) {
        try {
            const queryParams = { per_page: perPage.toString(), picker: '1' };
            if (searchQuery && searchQuery.trim()) {
                queryParams.q = searchQuery.trim();
            }
            const response = await apiService.back.get('knowledge.list', {
                queryParams
            });
            if (response.success) {
                return { success: true, data: response.data || [] };
            }
            else {
                return { success: false, data: [], error: 'API returned success=false' };
            }
        }
        catch (error) {
            console.error('Error loading knowledge entries:', error);
            return { success: false, data: [], error: error.message || 'Unknown error' };
        }
    }
    /**
     * Load knowledge entries for specific projects
     */
    static async loadKnowledgeForProjects(apiService, projectIds, perPage = 20) {
        try {
            const queryParams = {
                per_page: perPage.toString(),
                picker: '1',
                projectId: projectIds.join(',')
            };
            const response = await apiService.back.get('knowledge.list', {
                queryParams
            });
            if (response.success) {
                return { success: true, data: response.data || [] };
            }
            else {
                return { success: false, data: [], error: 'API returned success=false' };
            }
        }
        catch (error) {
            console.error('Error loading knowledge for projects:', error);
            return { success: false, data: [], error: error.message || 'Unknown error' };
        }
    }
    /**
     * Load all projects
     */
    static async loadProjects(apiService) {
        try {
            const response = await apiService.back.get('project.list', {
                queryParams: { all: '1' }
            });
            if (response.success) {
                return { success: true, data: response.data || [] };
            }
            else {
                return { success: false, data: [], error: 'API returned success=false' };
            }
        }
        catch (error) {
            console.error('Failed to load projects:', error);
            return { success: false, data: [], error: error.message || 'Unknown error' };
        }
    }
    /**
     * Create knowledge entry
     */
    static async createKnowledge(apiService, payload) {
        try {
            const response = await apiService.back.post('knowledge.create', payload);
            if (response.success) {
                return { success: true, data: response.data };
            }
            else {
                return { success: false, error: response.error || 'Failed to create knowledge' };
            }
        }
        catch (error) {
            console.error('Error creating knowledge:', error);
            return { success: false, error: error.message || 'Unknown error' };
        }
    }
    /**
     * Delete knowledge entry
     */
    static async deleteKnowledge(apiService, knowledgeId) {
        try {
            const response = await apiService.back.delete('knowledge.delete', {
                routeParams: { id: String(knowledgeId) }
            });
            if (response.success) {
                return { success: true };
            }
            else {
                return { success: false, error: response.error || 'Failed to delete knowledge' };
            }
        }
        catch (error) {
            console.error('Error deleting knowledge:', error);
            return { success: false, error: error.message || 'Unknown error' };
        }
    }
    /**
     * Build query parameters for knowledge search
     */
    static buildKnowledgeQueryParams(searchQuery, perPage = 20, projectId) {
        const params = {
            per_page: perPage.toString(),
            picker: '1'
        };
        if (searchQuery && searchQuery.trim()) {
            params.q = searchQuery.trim();
        }
        if (projectId) {
            params.projectId = projectId;
        }
        return params;
    }
}
exports.KnowledgeApiHelper = KnowledgeApiHelper;
